/** @format */

import ModalPopupStyle from "./ModalPopupStyle.module.scss";
import closeImage from "../../../../assets/images/close-popup.png";

const ModalPopup = ({
    title = "",
    handleClickClose = () => {},
    children,
    imageSrc = "",
    classCssMoreImage = "",
    classCssMoreFooter = "",
    style = {},
}) => {
    return (
        <div
            className={ModalPopupStyle.containerPopup_overlay}
            onClick={handleClickClose}>
            <div
                onClick={(e) => e.stopPropagation()}
                className={ModalPopupStyle.containerPopup}
                style={style}>
                <div
                    className={ModalPopupStyle.closeButton}
                    onClick={handleClickClose}>
                    <img src={closeImage} alt="close button" />
                </div>
                <div
                    className={
                        ModalPopupStyle.containerPopup_image +
                        " " +
                        classCssMoreImage
                    }>
                    <img src={imageSrc} alt="mochi mochi" />
                </div>
                <div className={ModalPopupStyle.containerPopup_title}>
                    {title}
                </div>
                <div
                    className={
                        ModalPopupStyle.container_footer +
                        " " +
                        classCssMoreFooter
                    }>
                    {children}
                </div>
            </div>
            <div className={ModalPopupStyle.containerPopup_children}></div>
        </div>
    );
};
export default ModalPopup;
